export const getTranslations = (key: string) => {
  const translationsDiv: HTMLDivElement | null = document.querySelector(
    "[data-translations]"
  );

  if (translationsDiv) {
    return translationsDiv.dataset[key];
  }
};
